import {
  CircleIcon_default
} from "./chunk-Q62O5P6I.mjs";
export {
  CircleIcon_default as default
};
